import { Axios } from "./axios";
import {
  HOST_API,
  HCCCD_API,
  CHANGE_PROFILE,
  CHANGE_PASSWORD,
  GET_INFO_BY_EMAIL,
  GET_MY_BUSINESSES,
  PHONE_VERIFY_SEND_OTP,
  PHONE_VERIFY_CONFIRM_OTP,
  ME_GIAY_TO,
  ME_GIAY_TO_FILE,
  ME_GIAY_TO_LOG_DOWNLOAD,
} from "../api";

function changeProfile(data) {
  return Axios("post", `${HOST_API}${CHANGE_PROFILE}`, data);
}

function changePassword(data) {
  return Axios("patch", `${HOST_API}${CHANGE_PASSWORD}`, data);
}

// ─── Lấy thông tin người dùng theo email ──────────────────────────────────────
function getInfoByEmail(email) {
  return Axios("get", `${HOST_API}${GET_INFO_BY_EMAIL}${"/"}${email}`);
}

function getMyBusinesses() {
  return Axios("get", `${HOST_API}${GET_MY_BUSINESSES}`);
}


// ─── Kho Giấy Tờ – gọi qua API nội bộ có kiểm soát quyền chủ sở hữu ──────────
// Endpoint: HOST_API + /api/me/giay-to  (congdan.services xác minh identity từ JWT)

function saveFileGiayTo(data) {
  return Axios("post", `${HOST_API}${ME_GIAY_TO}`, data);
}

function getFileListGiayTo(identity, query = "") {
  let filter = "{}";
  if (query) {
    filter = `{"tenGiayTo":{"$regex":"${query}","$options":"i"}}`;
  }
  return Axios("get", `${HOST_API}${ME_GIAY_TO}?filter=${filter}&count=true`);
}

function getFileGiayToById(id) {
  return Axios("get", `${HOST_API}${ME_GIAY_TO}/${id}`);
}

function getFileGiayToByFileId(fileId) {
  return Axios("get", `${HOST_API}${ME_GIAY_TO_FILE}/${fileId}`);
}

function updateFileGiayTo(id, data) {
  return Axios("patch", `${HOST_API}${ME_GIAY_TO}/${id}`, data);
}

function deleteFileGiayTo(id) {
  return Axios("delete", `${HOST_API}${ME_GIAY_TO}/${id}`);
}

function logDownloadGiayTo(data) {
  return Axios("post", `${HOST_API}${ME_GIAY_TO_LOG_DOWNLOAD}`, data);
}

function sendOTP(phone) {
  return Axios("post", `${HCCCD_API}${PHONE_VERIFY_SEND_OTP}`, { phone });
}

function confirmOTP(phone, otp) {
  return Axios("post", `${HCCCD_API}${PHONE_VERIFY_CONFIRM_OTP}`, {
    phone,
    otp,
  });
}

function verifyBusiness(maSoDoanhNghiep) {
  return Axios("post", `${HOST_API}${ME_GIAY_TO}/verify-business`, { maSoDoanhNghiep });
}

function fetchExternalFile(url) {
  return Axios("post", `${HOST_API}${ME_GIAY_TO}/fetch-external`, { url });
}

export {
  changeProfile,
  changePassword,
  getInfoByEmail,
  getMyBusinesses,
  sendOTP,
  confirmOTP,
  saveFileGiayTo,
  getFileListGiayTo,
  getFileGiayToById,
  getFileGiayToByFileId,
  updateFileGiayTo,
  deleteFileGiayTo,
  logDownloadGiayTo,
  verifyBusiness,
  fetchExternalFile,
};
